import React from 'react';
import { Modal } from '../modal/modal.js';
export const Sheet = ({ align = 'right', modal = true, ...rest }) => (React.createElement(Modal, { backdrop: modal, variant: align ? `sheet-${align}` : undefined, ...rest }));
